import { IFilterOptions } from './types';

export const createFilterOptions = (data) => {
  const filterOptions: IFilterOptions = {
    cdnOptions: [],
    asnOptions: [],
    policyOptions: [],
    triggerKpiOptions: [],
  };

  data.forEach((item) => {
    if (item.resource && !filterOptions.cdnOptions.some((option) => option.key === item.resource)) {
      filterOptions.cdnOptions.push({ key: item.resource, label: item.resource });
    }

    if (item.asnname && !filterOptions.asnOptions.some((option) => option.key === item.asnname)) {
      filterOptions.asnOptions.push({ key: item.asnname, label: item.asn + ' - ' + item.asnname });
    }

    if (item.policy && !filterOptions.policyOptions.some((option) => option.key === item.policy)) {
      filterOptions.policyOptions.push({ key: item.policy, label: item.policy });
    }

    if (
      item.triggerkpi &&
      !filterOptions.triggerKpiOptions.some((option) => option.key === item.triggerkpi)
    ) {
      filterOptions.triggerKpiOptions.push({ key: item.triggerkpi, label: item.triggerkpi });
    }
  });

  return filterOptions;
};
